import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['unsavedChanges'];

  showUnsavedChanges(){
    this.unsavedChangesTarget.style.display = 'flex'
  }
}
